import { useAuth } from '@/stores/auth';
import { PermissionDTO } from '@/api/trafikportalen';

interface PermissionsProps {
  permission: PermissionDTO;
}

export const checkUserPermissions = (props: PermissionsProps) => {
  const { permission } = props;

  const userPermissions = useAuth.getState().permissions || [];

  return userPermissions.includes(permission);
};

/**
 * True when the selected profile is not tied to an organisation (tenant or
 * system level). Organisation pages reached with such a profile, e.g. via
 * Back after leaving impersonation, would only get 403 from the API.
 */
export const isTenantProfile = () => {
  const { userProfile } = useAuth.getState();
  return !!userProfile && !userProfile.organization_id;
};

/**
 * Extended permission check that also considers department user access.
 * Use in beforeLoad route guards for pages accessible to both org admins
 * and department users with appropriate department access.
 */
export const checkRoutePermission = (props: PermissionsProps) => {
  if (checkUserPermissions(props)) return true;

  const { departmentAccess, permissions } = useAuth.getState();
  const hasOrgPermissions = permissions && permissions.length > 0;
  const hasDeptAccess = (departmentAccess?.accessible_departments || 0) > 0;

  if (!hasOrgPermissions && !hasDeptAccess) return false;

  if (props.permission === 'organization:viewer') return true;
  if (props.permission === 'organization:editor') {
    return (departmentAccess?.editor_departments || 0) > 0;
  }

  return false;
};
